import { createSelector } from "reselect";
import { selectCreateShipmentForm } from "./selectCreateShipmentForm";

export const selectBoxLabelingUnitsSelected = createSelector(
  selectCreateShipmentForm,
  (form) => form.dtcPrepOption.boxLabelingUnitsSelected
);
